import ShowroomForm from './ShowroomForm';
import Showroom from './Showroom';

const ShowroomConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/showrooms',
      element: <Showroom />,
    },
    {
      path: '/addShowroom',
      element: <ShowroomForm />,
    },
    {
      path: '/editShowroom/:id',
      element: <ShowroomForm />,
    },
  ],
};

export default ShowroomConfig;
